// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useEffect, useRef, useState } from "../00-boot.jsx";
import { lanacBootLocale, lanacLoadLocale, lanacLocaleLoaded } from "../i18n/loader.jsx";
import { lanacUidRange, authUrlFlow } from "../08-supabase-client.jsx";
import { splashSaute } from "../vitrine-regles.js";
// ── Tranche 1 · useUiPrefs : préférences & chrome UI transverses ────────────
//    lang (+persistance localStorage), splash minimum, toast « Annuler »,
//    modales vendeur/signalement. Corps des états copiés tels quels de App().
function useUiPrefs(){
  // Phase 1 lazy-load : l'état initial = la locale GARANTIE chargée au rendu
  // (lanacBootLocale = préférence localStorage validée si son pack a chargé,
  // sinon repli fr). On ne rend JAMAIS avec une locale au dictionnaire vide.
  const [lang,setLangState]=useState(()=>lanacBootLocale());
  // Persistance : UNIQUEMENT après une action utilisateur — un repli fr transitoire
  // (pack actif indisponible au boot) n'écrase pas la préférence mémorisée.
  const langTouchedRef=useRef(false);
  useEffect(()=>{ if(!langTouchedRef.current) return; try{localStorage.setItem("lanac:lang",lang);}catch{} },[lang]);
  // Bascule GARDÉE : si le pack de la locale cible est déjà chargé (cas nominal —
  // toutes les locales sont fetchées au boot), bascule synchrone identique à
  // l'ancien setLang ; sinon on charge PUIS on bascule (jamais d'UI à trous).
  const setLang=(l)=>{
    langTouchedRef.current=true;
    if(lanacLocaleLoaded(l)) setLangState(l);
    else lanacLoadLocale(l).then(()=>setLangState(l)).catch(()=>{});
  };
  // Durée MINI d'affichage du splash de démarrage : la vérif de session est souvent instantanée, sinon
  // l'animation (L → cercle qui tourne → LANAC) n'a pas le temps de jouer. On garde donc le splash tant
  // que l'auth n'est pas résolue OU que ce délai mini n'est pas écoulé. N'affecte AUCUNE logique d'auth.
  //  (05/11, V1 · Q1, élargi le même jour) un VISITEUR (aucune session rangée, hors /connexion) : le minimum est atteint d'emblée — la
  //   vitrine comme une annonce par son lien s'ouvrent sans les 2,5 s ; un membre les garde (décisions de Mounir)
  const [splashMinDone,setSplashMinDone]=useState(()=>{ try{ return splashSaute({uidRange:lanacUidRange(),fluxAuth:authUrlFlow(),chemin:location.pathname}); }catch(_){ return false; } });
  useEffect(()=>{ const t=setTimeout(()=>setSplashMinDone(true),2500); return()=>clearTimeout(t); },[]);
  const [undoToast,setUndoToast]=useState(null); // toast « Annuler » (suppression d'annonce) : {msg,undoLabel,id}
  const [sellerModal,setSellerModal]=useState(null);
  const [reportModal,setReportModal]=useState(null);
  return {lang,setLang,splashMinDone,setSplashMinDone,undoToast,setUndoToast,sellerModal,setSellerModal,reportModal,setReportModal};
}
export { useUiPrefs };
